import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirplanemodeOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airplanemode_off"}/>
}
